'use client';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { text5, textBlue } from '@osmosis/tailwind-ui/styles/text';

import React from 'react';

import { FormattedMessage } from 'react-intl';

/**
 * AuthContactUs.
 */
const AuthContactUs = () => {
  return (
    <Box className="text-center">
      <Box className="p-4">
        <P className={cn('m-3 mb-4 max-w-[400px]', text5)}>
          <FormattedMessage
            id="auth-form.education_program-description"
            defaultMessage="Interested in using Osmosis in your health education program to achieve your teaching and learning goals?"
          />
        </P>
        <a
          href="/educators/medicine-md"
          target="_blank"
          data-testid="auth-form.education_program-contact_us"
          className={`cursor-pointer pt-4 ${textBlue} text-sm font-bold sm:text-base`}
        >
          <FormattedMessage
            id="auth-form.education_program-contact_us"
            defaultMessage="Contact us today!"
          />
        </a>
      </Box>
    </Box>
  );
};

export default AuthContactUs;
